.action-panel {
  display: flex;
  gap: 10px;
}
.btn.default {
  background: #eee;
  border: 1px solid #ccc;
  padding: 8px 16px;
}
.btn.primary {
  background: blue;
  color: white;
  padding: 8px 16px;
}
.btn.danger {
  background: red;
  color: white;
  padding: 8px 16px;
}